import React from "react";

export const Footer: React.FC = () => {
    return <footer className={"font-myriad"}
                   style={{background: "linear-gradient(270deg, #4DD4FF 47.5%, #4ACAF9 57.48%, #43B0EA 73.68%, #3B90D9 91.14%, #3780D1 98.62%, #316DC6 107.35%)"}}>
        <div className={"py-[2.5rem] px-4 max-w-[1200px] mx-auto"}>
            <ul className={"text-white"}>
                <li className={"font-bold"}>CÔNG TY CỔ PHẦN VTC TRUYỀN THÔNG TRỰC TUYẾN</li>
                <li>Địa chỉ: Tầng 12, Tòa nhà VTC Online, 18 Tam Trinh, Phường Minh Khai, Quận Hai Bà Trưng, Hà Nội, Việt Nam</li>
            </ul>
        </div>
    </footer>
}
